module.exports = __webpack_public_path__ + "img/Miles Circle.e908d187.png";